import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var passwordBaseTextField = 'fx_c76f37be_sregt60';
var passwordIconRoot = createRuntimeFn({defaultClassName:'fx_c76f37be_sregt61',variantClassNames:{size:{small:'fx_c76f37be_sregt62','default':'fx_c76f37be_sregt63',large:'fx_c76f37be_sregt64',xlarge:'fx_c76f37be_sregt65'}},defaultVariants:{},compoundVariants:[]});
var passwordTypeToggleButton = 'fx_c76f37be_sregt66';

export { passwordBaseTextField, passwordIconRoot, passwordTypeToggleButton };
//# sourceMappingURL=passwordTextField.vanilla.mjs.map
